import { SCREENS } from "utils/constants";
import Contacts from "./Contacts";
import Handover from "./Handover";
import Processes from "./Processes";
import Quotes from "./Quotes";

const screens = [
  // {
  //   exact: false,
  //   path: SCREENS.PUBLIC.INDEX.path,
  //   element: <Welcome />,
  // },
  {
    exact: false,
    path: SCREENS.PUBLIC.CONTACTS.INDEX.path,
    element: <Contacts />,
  },
  {
    exact: true,
    path: SCREENS.PUBLIC.HANDOVER.path,
    element: <Handover />,
  },
  ...Processes,
  ...Quotes,
];

export default screens;
